import React, { useState, useEffect } from "react";
import BasicDetail from "./BasicDetail";
import PersonalDetail from "./PersonalDetail";
import EmployeeDetail from "./EmployeeDetail";
import InvestingDetail from "./InvestingDetail";
import AccountDetail from "./AccountDetails";
import AccountClosure from "./AccountClosure";
import CustomSpinner from "../../Common/Spinner";
import IdentificationDetails from "./IdentificationDetails";

const Detail = ({ userData, getDetails, custId, featureAccess, listStatus, refreshListStatus, countryOptions = [], loadingCountries = false  }) => {
  const isEditable = featureAccess?.modifyAccess || false;


  if (Object.keys(userData).length === 0 || loadingCountries) {
    return <CustomSpinner />;
  }
   const refreshDetails = async () => {
    await getDetails(custId);
    if (refreshListStatus) {
      await refreshListStatus(custId);
    }
  };

  const detailComponents = [
    BasicDetail,
    PersonalDetail,
    EmployeeDetail,
    InvestingDetail,
    AccountDetail,
    IdentificationDetails,
    AccountClosure,
  ];

  return (
    <>
      {detailComponents.map((Component, index) => (
        <Component
          key={index}
          data={userData}
          isEditable={isEditable}
          refreshDetails={refreshDetails}
          custId={custId}
          listStatus={listStatus}
          refreshListStatus={refreshListStatus}
          countryOptions={countryOptions}
        />
      ))}
    </>
  );
};

export default React.memo(Detail);
